import styled from 'styled-components';

export const RowWrapper = styled.div`
  display: grid;
  grid-template-columns: max-content auto max-content;
  padding: 0 4rem;
  width: 1152px;
  overflow: visible;
  justify-content: stretch;
  z-index: 10;

  & img {
    margin: 0.875rem 0 0 0;
  }

  & #getYourQuote > div {
    margin: 1.5rem 0 0 1rem;
    font-size: 16px;
    padding: 9px 20px;
    width: auto;
    font-style: normal;
    font-weight: 500;
    line-height: 100%; /* 16px */
    letter-spacing: 1.25px;
  }

  & nav {
    overflow: visible;
    overscroll-behavior-y: none;
    margin: 0;
    justify-self: flex-end;
  }

  & nav > ul {
    display: flex;

    & > li {
      position: relative;
      padding: 2.125rem 1rem 1.125rem 1rem;
      font-size: 1rem;
      font-style: normal;
      font-weight: 500;
      line-height: 120%;
      letter-spacing: 0.25px;

      & > div {
        gap: 12px;
        margin: 0;
      }

      & ul {
        position: absolute;
        left: 0;
        padding: 1.5rem;
        margin-top: 1.125rem;
        width: 252px;
        background-color: #f7faf9;
        box-shadow: 0px 1px 3px 0px rgba(60, 60, 59, 0.12);

        & li:last-child {
          margin: 0;
        }
      }
    }
  }
`;
